import { render, staticRenderFns } from "./ws5-work-type-repeat.vue?vue&type=template&id=6cbfe1e7"
import script from "./ws5-work-type-repeat.vue?vue&type=script&lang=js"
export * from "./ws5-work-type-repeat.vue?vue&type=script&lang=js"
import style0 from "./ws5-work-type-repeat.vue?vue&type=style&index=0&id=6cbfe1e7&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports